<template id="app">
    <div>
      <HeaderComponent :headerTitle="headerText" :router-link="getRouterLink()" :router-link-text="getRouterLinkText()"
        :return-condition="true" :component-name="componentsName()" />

        <!-- add image popup -->
    <v-row justify="center">
      <v-dialog v-model="addImagesPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0">
            <v-card-title>
              <v-row class="ma-1">
              <span>Select Images</span>
              <v-spacer></v-spacer>
              <!-- <v-btn icon @click="closeImageDialog"> -->
                <v-icon icon @click="closeImageDialog">mdi-close</v-icon>
              <!-- </v-btn> -->
            </v-row>
            </v-card-title>
          </v-card>
          <v-row>
            <v-col v-for="(image, index) in requestImages" :key="image" cols="3" class="m-3">
              <div class="image-container">                
                <img :src="image" alt="Lot Image" class="image-rad-size" @click="openImagePopupSingle(image)"/>
                <div class="cancel-icon" @click="removeImage(index)">
                  <v-icon>mdi-close</v-icon>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-card-text class="mt-3">
            <label for="fileInput" class="icon-container">
              <v-icon color="#91C6FF" class="custom-icon" size="25">mdi-plus</v-icon>
            </label>
            <input type="file" id="fileInput" multiple accept="image/*" @change="handleImageUpload" style="display: none" />
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" class="cancel-color mb-3" @click="closeImageDialog">Cancel</v-btn>
            <v-btn color="primary"  variant="flat" @click="handleFileChange" class="mb-3">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="imagePopup" max-width="600px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="imagePopup = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-img :src="selectedImage" width="100%" contain></v-img>
      </v-card>
    </v-dialog>
    <v-dialog v-model="approveDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <v-row class="ma-1">
          <span>Proof Document</span>
          <v-spacer></v-spacer>
          <!-- <v-btn icon @click="approveDialog = false"> -->
            <v-icon @click="approveDialog = false">mdi-close</v-icon>
          <!-- </v-btn> -->
        </v-row>
        </v-card-title>
        <v-card-text class="mt-3">
          <v-file-input 
            class="upload" 
            v-model="file" 
            variant="outlined" 
            label="Upload Proof Document" 
            prepend-inner-icon="mdi-paperclip"
            prepend-icon=""
            accept=".pdf, .png" 
            @change="changeFile" 
            :error="fileError" 
            :error-messages="fileErrorMessage">
          </v-file-input>
        </v-card-text>
        <v-card-actions center>
          <v-spacer></v-spacer>
          <v-btn variant="outlined" class="cancel-color mb-3 text-none" @click="approveDialog = false">Cancel</v-btn>
          <v-btn color="primary"  variant="flat" @click="submitDocument" class="mb-3 text-none">Submit</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

   <!--  atach image  popup-->
       <v-row justify="center">
          <v-dialog v-model="attachImagePopup" persistent max-width="424px">
            <v-card class="v-card-100">
             <v-card class="v-card-100 mt-0 custom-shadow">
            <v-card-title class="pa-0">
              <v-row class="ma-1">
              <span>Attached Images</span>
              <v-spacer></v-spacer>
                <v-icon @click="attachImagePopup = false">mdi-close</v-icon>
            </v-row>
            </v-card-title>
            </v-card>
              <v-card-text class="text-center">
                <div v-if="attach_images.length">
                  <img :src="attach_images[currentImageIndex]" alt="Image" class="image-fit" style="max-height: 400px; width: 100%;" />
                  <v-row justify="center" align="center" class="mt-3">
                    <v-btn icon :disabled="currentImageIndex === 0" @click="prevImage">
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <span class="mx-2">{{ currentImageIndex + 1 }} / {{ attach_images.length }}</span>
                    <v-btn icon :disabled="currentImageIndex === attach_images.length - 1" @click="nextImage">
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-row>
                </div>
                <div v-else>
                  <p>No images found.</p>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
  
      <v-card class="v-card v-sheet theme--light overflow-auto mt-0 text-left" style="max-width: 100% !important;" :height="minTableHeight" v-if="(action == 'Logistics Requests' && !(inventoryId === 'Failed Status' || track_id_request === 'lr_trip_id')) || action == 'Create Trips'">
        <v-card-text>
  
          
          <div style="background: #EAF4FF;padding: 12px;">
            <v-row>
              <v-col class="d-flex flex-column">
                <span>CRM Ticket No</span>
                <span class="value_css">{{ result.client_crm_ticket_no ? result.client_crm_ticket_no : result.crm_ticket_number ? result.crm_ticket_number : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>BB Ticket No</span>
                <span class="value_css">{{ result.bb_ticket_no ? result.bb_ticket_no : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Sub Request ID</span>
                <span class="value_css">{{ result.return_sub_request_id ? result.return_sub_request_id : result.sub_request_number ?  result.sub_request_number : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Request Creation Date</span>
                <span class="value_css">{{ formattedRequestCreationDate }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex flex-column">
                <span>Ageing(Days)</span>
                <span class="value_css">{{ result.ageing ? result.ageing : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Created By</span>
                <span class="value_css">{{ result.created_by ? result.created_by : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Status</span>
                <span class="value_css">{{ result.status ? result.status : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
              </v-col>
            </v-row>
          </div>
  
          <!-- Customer Details -->
          <div v-if="action == 'Logistics Requests'">
            <div style="background: #EAF4FF;padding: 12px;color:#002F9E; font-size: 18px;font-weight: 600;margin-top: 16px;">
              <span>Customer Details</span>
            </div>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Name*</span>
                <span class="value_css">{{ result.customer_name ? result.customer_name : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Type</span>
                <span class="value_css">{{ result.customer_details_type ? result.customer_details_type : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Primary No.*</span>
                <span class="value_css">{{ result.customer_primary_no ? result.customer_primary_no : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Alternate No.</span>
                <span class="value_css">{{ result.customer_alternate_no ? result.customer_alternate_no : '-' }}</span>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Address*</span>
                <span class="value_css">{{ result.item_location ? result.item_location : '-' }}</span>
              </v-col>
            </v-row>
          </div>
  
          <!-- Logistics Request Details -->
          <div v-if="action == 'Create Trips'">
            <div style="background: #EAF4FF;padding: 12px;color:#002F9E; font-size: 18px;font-weight: 600;margin-top: 16px;">
              <span>Logistics Request Details</span>
            </div>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Activity type</span>
                <span class="value_css">{{ result.activity_type ? result.activity_type : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Activity Location</span>
                <span class="value_css">{{ result.activity_location ? result.activity_location : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Primary No.*</span>
                <span class="value_css">{{ result.primary_number ? result.primary_number : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Alternate No.</span>
                <span class="value_css">{{ result.alternate_contact_no ? result.alternate_contact_no : '-' }}</span>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Address*</span>
                <span class="value_css">{{ result.address ? result.address : '-' }}</span>
              </v-col>
            </v-row>
          </div>
  
          <!-- Return shipment -->
          <div v-if="action == 'Logistics Requests'">
            <div style="background: #EAF4FF;padding: 12px;color:#002F9E; font-size: 18px;font-weight: 600;margin-top: 16px;">
              <span>Return Shipment</span>
            </div>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Article ID</span>
                <span class="value_css">{{ result.return_shipment && result.return_shipment.article_id ? result.return_shipment.article_id : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Serial Number</span>
                <span class="value_css">{{ result.return_shipment && result.return_shipment.serial_number ? result.return_shipment.serial_number : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Document Type</span>
                <span class="value_css">{{ result.return_shipment && result.return_shipment.document_type ? result.return_shipment.document_type : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Document No</span>
                <span class="value_css">{{ result && result.irrd_number ? result.irrd_number : '-' }}</span>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Article Description</span>
                <span class="value_css">{{ result.return_shipment && result.return_shipment.article_description ? result.return_shipment.article_description : '-' }}</span>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>From</span>
                <span class="value_css">{{ result.return_shipment && result.return_shipment.from ? result.return_shipment.from : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>POC</span>
                <span class="value_css">{{ result.return_shipment && result.return_shipment.from_poc ? result.return_shipment.from_poc : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>POC Phone no</span>
                <span class="value_css">{{ result.return_shipment && result.return_shipment.from_poc_contact_number ? result.return_shipment.from_poc_contact_number : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>To</span>
                <span class="value_css">{{ result.return_shipment && result.return_shipment.to ? result.return_shipment.to : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>POC</span>
                <span class="value_css">{{ result.return_shipment && result.return_shipment.to_poc ? result.return_shipment.to_poc : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>POC Phone no</span>
                <span class="value_css">{{ result.return_shipment && result.return_shipment.to_poc_contact_number ? result.return_shipment.to_poc_contact_number : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
              </v-col>
            </v-row>
          </div>
  
          <div v-if="action == 'Create Trips'">
            <div style="background: #EAF4FF;padding: 12px;color:#002F9E; font-size: 18px;font-weight: 600;margin-top: 16px;">
              <span>Return Shipment</span>
            </div>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Article ID</span>
                <span class="value_css">{{ result && result.article_id ? result.article_id : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Serial Number</span>
                <span class="value_css">{{ result && result.serial_number ? result.serial_number : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Document Type</span>
                <span class="value_css">{{ result && result.document_type ? result.document_type : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Document No</span>
                <span class="value_css">{{ result && result.irrd_number ? result.irrd_number : '-' }}</span>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Article Description</span>
                <span class="value_css">{{ result && result.article_description ? result.article_description : '-' }}</span>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>From</span>
                <span class="value_css">{{ result && result.from ? result.from : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>POC</span>
                <span class="value_css">{{ result && result.from_poc ? result.from_poc : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>POC Phone no</span>
                <span class="value_css">{{ result && result.from_poc_contact ? result.from_poc_contact : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>To</span>
                <span class="value_css">{{ result && result.to ? result.to : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>POC</span>
                <span class="value_css">{{ result && result.to_poc ? result.to_poc : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>POC Phone no</span>
                <span class="value_css">{{ result && result.to_poc_contact ? result.to_poc_contact : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
              </v-col>
            </v-row>
          </div>
  
          <!-- Replacement Shipment -->
           <div v-if="action == 'Logistics Requests' && result.request_type === 'Replacement'">
            <div style="background: #EAF4FF;padding: 12px;color:#002F9E; font-size: 18px;font-weight: 600;margin-top: 16px;">
              <span>Replacement Shipment</span>
            </div>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Article ID</span>
                <span class="value_css">{{ result.replacement_shipment && result.replacement_shipment.article_id ? result.replacement_shipment.article_id : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Serial Number</span>
                <span class="value_css">{{ result.replacement_shipment && result.replacement_shipment.serial_number ? result.replacement_shipment.serial_number : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Document Type</span>
                <span class="value_css">{{ result.replacement_shipment && result.replacement_shipment.document_type ? result.replacement_shipment.document_type : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Document No</span>
                <span class="value_css">{{ result && result.orrd_number ? result.orrd_number : '-' }}</span>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Article Description</span>
                <span class="value_css">{{ result.replacement_shipment && result.replacement_shipment.article_description ? result.replacement_shipment.article_description : '-' }}</span>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>From</span>
                <span class="value_css">{{ result.replacement_shipment && result.replacement_shipment.from ? result.replacement_shipment.from : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>POC</span>
                <span class="value_css">{{ result.replacement_shipment && result.replacement_shipment.from_poc ? result.replacement_shipment.from_poc : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>POC Phone no</span>
                <span class="value_css">{{ result.replacement_shipment && result.replacement_shipment.from_poc_contact_number ? result.replacement_shipment.from_poc_contact_number : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>To</span>
                <span class="value_css">{{ result.replacement_shipment && result.replacement_shipment.to ? result.replacement_shipment.to : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>POC</span>
                <span class="value_css">{{ result.replacement_shipment && result.replacement_shipment.to_poc ? result.replacement_shipment.to_poc : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>POC Phone no</span>
                <span class="value_css">{{ result.replacement_shipment && result.replacement_shipment.to_poc_contact_number ? result.replacement_shipment.to_poc_contact_number : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
              </v-col>
            </v-row>
          </div>
  
          <!-- Other Details -->
          <div v-if="action == 'Logistics Requests'">
            <div style="background: #EAF4FF;padding: 12px;color:#002F9E; font-size: 18px;font-weight: 600;margin-top: 16px;">
              <span>Other Details</span>
            </div>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Channel</span>
                <span class="value_css">{{ result.channel ? result.channel : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Return Sub-Type</span>
                <span class="value_css">{{ result.return_request_sub_type ? result.return_request_sub_type : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Return Reason</span>
                <span class="value_css">{{ result.return_reason ? result.return_reason : '-' }}</span>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Return Sub-Reason</span>
                <span class="value_css">{{ result.return_sub_reason ? result.return_sub_reason : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Branch</span>
                <span class="value_css">{{ result.branch ? result.branch : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Region</span>
                <span class="value_css">{{ result.region ? result.region : '-' }}</span>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col class="d-flex flex-column">
                <span>Zone</span>
                <span class="value_css">{{ result.zone ? result.zone : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Sales Manager</span>
                <span class="value_css">{{ result.sales_manager ? result.sales_manager : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Customer Service Executive</span>
                <span class="value_css">{{ result.customer_service_executive ? result.customer_service_executive : '-' }}</span>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
  
      <v-card v-if="action == 'Track Trips' || track_id_request === 'lr_trip_id'" class="mt-6 v-card-100">
        <v-card class="v-card-100">
        <v-card-title class="pt-5 mx-2">
          <v-row>
            <v-autocomplete v-model="select_field" item-title="name" item-value="id" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px;" class="mr-4 text-left"> </v-autocomplete>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" class="search_style" variant="outlined" style="max-width: 300px;" v-on:keyup.enter="getShowItem" />
            <v-spacer />
            <v-btn color="primary" size="x-large" class="text-none mr-2" :disabled="selected.length == 0" @click="triggerFileInput">Upload Images</v-btn>
            <v-btn color="primary" size="x-large" class="text-none mr-2" disabled @click="rejectTrip">Reject</v-btn>
            <v-btn color="primary" size="x-large" class="text-none mr-2" :disabled="(selected.length != 1 || !selected.every(item=> item.status?.toLowerCase() == 'pending approval'))" @click="approveTrip">Approve</v-btn>
          </v-row>
        </v-card-title>
      </v-card>
        <v-card-text class="pa-0">
          <div style="background: #EAF4FF;">
            <v-row class="pa-3">
              <v-col class="d-flex flex-column">
                <span>Vehicle No</span>
                <span class="value_css">{{ result && result.trip && result.trip.vehicle_number ? result.trip.vehicle_number : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Vehicle Type</span>
                <span class="value_css">{{ result && result.trip && result.trip.vehicle_type ? result.trip.vehicle_type : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Executive Name</span>
                <span class="value_css">{{ result && result.trip && result.trip.logistic_executive ? result.trip.logistic_executive : '-' }}</span>
              </v-col>
              <v-col class="d-flex flex-column">
                <span>Contact Number</span>
                <span class="value_css">{{ result && result.trip && result.trip.executive_contact ? result.trip.executive_contact : '-' }}</span>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
  
      <v-card v-if="(action == 'Track Trips' || track_id_request === 'lr_trip_id') || ((action == 'Logistics Requests' && inventoryId == 'Failed Status'))" class="mt-6 v-card-100 track_id_table">
        <v-layout column>
          <!-- <v-flex md6 style="overflow: auto"> -->
            <v-data-table
              :dense="true"
              disable-pagination
              density="compact"
              :hide-default-footer="true"
              :headers="(action == 'Track Trips' || track_id_request === 'lr_trip_id') ? headers_for_tracktrip : headers_for_failed"
              :items="result.activities"
              :loading="loading"
              show-select
              fixed-header
              return-object
              height="100%"
              loading-text="Loading Data... Please wait"
              class="elevation-1"
              :items-per-page="result?.activities?.length"
              :class="{
                'track-trips-table': action == 'Track Trips',
                'logistics-requests-failed-table': action == 'Logistics Requests' && inventoryId == 'Failed Status'
              }"
            >
            <template #headers="{ columns }">
                <tr>
                  <th>
                    <v-checkbox
                      :model-value="isAllSelectableSelected"
                      :indeterminate="isIndeterminate"
                      @click.stop="toggleSelectableItems"
                      hide-details
                      color="primary"
                      style="max-height: 40px !important;margin: -14px 0px 0px -6px;"
                    />
                  </th>
                  <th v-for="column in columns.slice(1)" :key="column.key">
                    {{ column.title }}
                  </th>
                </tr>
              </template>
            <template #item.data-table-select="{ item }">
              <v-checkbox
                :model-value="selected.includes(item)"
                :disabled="isRowDisabled(item)"
                @update:modelValue="val => toggleSelect(item, val)"
                density="compact"
                hide-details
                class="ml-2"
              />
            </template>
            <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers_for_tracktrip">
              <span v-if="header.key == 'logistic_request_id'">
                <a href="#" @click.prevent="fetchLogisticDetail(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.logistic_request_id }}</a>
              </span>
              <span v-else-if="header.key == 'sub_request_id'">
                <a href="#" @click.prevent="returnRequestDetailPopup(item, 'Sub Request ID')" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.sub_request_id }}</a>
              </span> 
              <span v-else-if="header.key == 'trip_assignment_date'">
                {{ item.trip_assignment_date ? item.trip_assignment_date.split('-').reverse().join('/') : '-' }}
              </span> 
              <span v-else-if="header.key == 'activity_date_time'">
                {{ item.activity_date_time ? correctDateFormat(item.activity_date_time) : '-' }}
              </span> 
              <span v-else-if="header.key == 'status'">
                {{ item.status ? item.status : '-' }}
              </span> 
              <span v-else-if="header.key == 'trip_sequence'">
                {{ item.trip_sequence ? item.trip_sequence : '-' }}
              </span>
              <!-- <span v-else-if="header.key == 'activity_type'">
                {{ item.activity_type ? item.activity_type : '-' }}
              </span> -->
              <span v-else-if="header.key === 'view'">
                <span v-if="item.attached_urls.length > 0">
                <a @click="openAttachDoc(item)" style="color: #1976d2; cursor: pointer;text-decoration: underline">
                  <span>
                    <u>View</u>
                  </span>
                </a> 
                </span>
                <span v-else>-</span>
                </span>
               <span v-else-if="header.key == 'activity_location'">
                    <template v-if="item.activity_location && item.activity_location.length > 15">
                      <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                          <span v-bind="props" v-on="on">
                            {{ item.activity_location.substring(0, 15) + '...' }}
                          </span>
                        </template>
                        <span style="white-space: nowrap;">{{ item.activity_location }}</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      {{ item.activity_location ? item.activity_location : '-' }}
                    </template>
                </span>
              <span v-else-if="header.key === 'aggregation_id'">
                <span v-if="item.aggregation_id">
                  {{ item.aggregation_id }}
                  <span @click="toggleExpand(item)" v-if="isDuplicate(item)">
                    <v-icon color="primary" v-if="!item.is_expanded">mdi-plus</v-icon>
                    <v-icon color="primary" v-else>mdi-minus</v-icon>
                  </span>
                  </span>
                <span v-else>-</span>
              </span>
              <span v-else-if="header.key !== 'images' && item[header.key]">
                 <GlobalTooltip :text="item[header.key]" />
              </span>
            <span v-else>-</span>
            </template>
              <!-- <template #[`item.logistic_request_id`]="{ item }">
                <span v-if="item.logistic_request_id" style="color: #1976d2; cursor: pointer;text-decoration: underline;" @click="fetchLogisticDetail(item)">{{ item.logistic_request_id }}
                </span>
                <span v-else>-</span>
              </template> -->
              <template #bottom></template>
            </v-data-table>
          <!-- </v-flex> -->
        </v-layout>
        <div>
          <v-row class="ml-2 pb-4">
              <span class="PaddingItemPerPage d-flex mt-4">
                <label class="" style="margin-top: -2px;">Rows Per Page</label>
                <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui"  @update:modelValue="handlePageSizeChange"
                    variant="outlined" density="compact" style="margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
              </span>
              <span class="item-selected" :style="this.totalCount > 9999 ? 'left:24% !important;' : ''"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
                v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
              <v-spacer></v-spacer>
              <div class="d-flex">
                <span :class="this.totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
                - {{ Math.min(this.page * result?.activities?.length, result?.activities?.length) }} of {{ result?.activities?.length }}</span>
                <span class="PaddingItemPerPage mr-3" :style="totalPages>7 ? 'min-width: 380px' : 'auto'">
                    <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
                      @update:modelValue="handlePageChange" density="compact" rounded="circle"></v-pagination>
                </span>
              </div>
          </v-row>
        </div>
      </v-card>
      <!-- reference popup -->
      <v-row justify="center">
        <v-dialog v-model="referenceDocPopup" persistent max-width="800px">
          <v-card class="v-card-100">
            <v-card class="v-card-100 mt-0">
              <v-card-title>
                <v-row class="ma-1">
                <span>Logistics Request ID: <span style="color:#79747E;font-weight: 400;">{{ itemInformation.logistic_request_id ? itemInformation.logistic_request_id : '-' }}</span>
                </span>
                <v-spacer></v-spacer>
                <!-- <v-btn icon @click="referenceDocPopup = false"> -->
                  <v-icon  @click="referenceDocPopup = false">mdi-close</v-icon>
                <!-- </v-btn> -->
              </v-row>
              </v-card-title>
            </v-card>
            <v-card-text>
              <!-- <div style="font-weight: 500;padding:12px 0px;">{{ itemInformation.request_type }}</div> -->
              <v-row style="background: #EAF4FF;padding: 0px 12px;">
                <v-col class="d-flex flex-column">
                  <span>ORRD Type</span>
                  <span class="value_css">{{ referenceDocData.orrd_type ? referenceDocData.orrd_type : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>ORRD Number</span>
                  <span class="value_css">{{ referenceDocData.orrd_number ? referenceDocData.orrd_number : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Item Count</span>
                  <span class="value_css">{{ referenceDocData.quantity ? referenceDocData.quantity : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>ORD Number</span>
                  <span class="value_css">{{ referenceDocData.ord_number ? referenceDocData.ord_number : '-' }}</span>
                </v-col>
              </v-row>
                  
              <div>
                <v-layout column class="mt-6">
                  <!-- <v-flex md6 style="overflow: auto">
                    <v-list-item-content class="p-0"> -->
                      <v-data-table 
                        :dense="true"
                        :headers="itemsHeaders"
                        :items="itemsTableData"
                        style="max-height: 300px;height:auto !important;" 
                        disable-pagination
                        density="compact"
                        return-object 
                        :hide-default-footer="true"
                        class="elevation-1">
                        <template v-slot:[`item.${headers.key}`]="{ item }" v-for="headers in itemsHeaders">
                          <span v-if="headers.key !== 'imags' && item[headers.key]">
                            <span v-tooltip="item[headers.key]">
                              {{ item[headers.key].length > 20 ? item[headers.key].slice(0, 20) + '...' : item[headers.key] }}
                            </span>
                          </span>
                          <span v-else>-</span>
                        </template>
                        <!-- <template #[`item.weight`]="{ item }">
                          <span>{{ item.weight ? item.weight : "-" }}</span>
                        </template>
                        <template #[`item.volumentric_weight`]="{ item }">
                          <span>{{ item.volumentric_weight ? item.volumentric_weight : "-" }}</span>
                        </template> -->
                        <template #bottom></template>
                      </v-data-table>
                    <!-- </v-list-item-content>
                  </v-flex> -->
                </v-layout>
              </div>
  
              <div style="background: #EAF4FF;padding: 12px;color:#002F9E; font-size: 16px;font-weight: 400;margin-top: 16px;">
                <span>Pickup Details</span>
              </div>
  
              <v-row class="px-3">
                <v-col class="d-flex flex-column">
                  <span>Address</span>
                  <span class="value_css" v-if="referenceDocData.pickup_details">{{ referenceDocData.pickup_details.address ? referenceDocData.pickup_details.address : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>City</span>
                  <span class="value_css" v-if="referenceDocData.pickup_details">{{ referenceDocData.pickup_details.city ? referenceDocData.pickup_details.city : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Pin Code</span>
                  <span class="value_css" v-if="referenceDocData.pickup_details">{{ referenceDocData.pickup_details.pin_code ? referenceDocData.pickup_details.pin_code : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>State</span>
                  <span class="value_css" v-if="referenceDocData.pickup_details">{{ referenceDocData.pickup_details.state ? referenceDocData.pickup_details.state : '-' }}</span>
                </v-col>
              </v-row>
              <v-row class="px-3">
                <v-col class="d-flex flex-column">
                  <span>POC Name</span>
                  <span class="value_css" v-if="referenceDocData.pickup_details">{{ referenceDocData.pickup_details.poc_name ? referenceDocData.pickup_details.poc_name : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>POC Contact No.</span>
                  <span class="value_css" v-if="referenceDocData.pickup_details">{{ referenceDocData.pickup_details.poc_contact_number ? referenceDocData.pickup_details.poc_contact_number : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Vehicle Number</span>
                  <span class="value_css" v-if="referenceDocData.pickup_details">{{ referenceDocData.pickup_details.vehicle_number ? referenceDocData.pickup_details.vehicle_number : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Vehicle Type</span>
                  <span class="value_css" v-if="referenceDocData.pickup_details">{{ referenceDocData.pickup_details.vehicle_type ? referenceDocData.pickup_details.vehicle_type : '-' }}</span>
                </v-col>
              </v-row>
              <v-row class="px-3">
                <v-col class="d-flex flex-column">
                  <span>Logistic Executive</span>
                  <span class="value_css" v-if="referenceDocData.pickup_details">{{ referenceDocData.pickup_details.logistic_executive ? referenceDocData.pickup_details.logistic_executive : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Logistic Executive Contact No</span>
                  <span class="value_css" v-if="referenceDocData.pickup_details">{{ referenceDocData.pickup_details.logistic_executive_contact ? referenceDocData.pickup_details.logistic_executive_contact : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Logistic Assistant</span>
                  <span class="value_css" v-if="referenceDocData.pickup_details">{{ referenceDocData.pickup_details.logistic_assistance ? referenceDocData.pickup_details.logistic_assistance : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Logistic Assistant Contact No</span>
                  <span class="value_css" v-if="referenceDocData.pickup_details">{{ referenceDocData.pickup_details.logistic_assistance_contact ? referenceDocData.pickup_details.logistic_assistance_contact : '-' }}</span>
                </v-col>
              </v-row>
  
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </template>
  <script>
    import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";
    import Loading from 'vue-loading-overlay';
    import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
    // import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
      components : {
    HeaderComponent
  },
  data(){
    return {
      headerText: "FTA",
      alert : false,
      alert_type : "success",
      alert_message : '',
      search_tag: '',
      minTableHeight: "200px",
      result: {},
      action: '',
      page: 1,
      totalPages: 1,
      totalCount: 10,
      pageSize: 1,
      pageSizes: defaultPageSizes,
      referenceDocPopup: false,
      itemInformation : {},
      referenceDocData:{},
      itemsTableData: [],
      crm_ticket_dupl_details : {},
      select_field_items: [
      {
              "name":"CRM Ticket No",
              "id": "crm_ticket_no"
            },
            {
              "name":"Sub-request ID",
              "id": "sub_request_id"
            },
            {
              "name":"LR id Doc No",
              "id": "lr_id"
            },
      ],
      select_field: 'crm_ticket_no',
        itemsHeaders: [
        { title : 'Article ID', key : 'article_id', minWidth: "200px"},
        { title : 'Article Description', key :'article_description', minWidth: "230px"},
        { title : 'Weight', key : 'weight', minWidth: "200px"},
        { title : 'Volumetric Weight', key : 'volumentric_weight', minWidth: "250px"},
      ],
      headers_for_tracktrip : [
        { title : 'Trip Assignment Date', key : 'trip_assignment_date', minWidth: "250px"},
        { title : 'Aggregation ID', key : 'aggregation_id', minWidth: "200px !important"},
        { title : 'Sub-request ID', key : 'sub_request_id', minWidth: "250px "},
        { title : 'Logistics FTA Request ID', key : 'logistic_request_id', minWidth: "250px"},
        { title : 'CRM Ticket No', key : 'crm_ticket_number', minWidth :'200px !important'},
        { title : 'Activity Type', key : 'activity_type', minWidth: "200px"},        
        { title : 'Trip Sequence', key : 'trip_sequence', minWidth: "200px"},
        { title : 'Activity Location', key : 'activity_location', minWidth: "200px"},
        { title : 'City', key : 'city', minWidth: "200px"},
        { title : 'State', key : 'state', minWidth: "200px"},
        { title : 'Pincode', key : 'pincode', minWidth: "200px"},
        { title : 'Activity Date & Time', key : 'activity_date_time', minWidth: "250px"},
        { title : 'Status', key : 'status', minWidth: "200px"},
        { title : 'Attach Doc', key : 'view', minWidth: "200px"},
      ],
      headers_for_failed : [
        { title : 'Trip Assignment Date', key : 'trip_assignment_date'},
        { title : 'Logistics FTA Request ID', key : 'logistic_request_id'},
        { title : 'CRM Ticket No', key : 'crm_ticket_number'},
        { title : 'Activity Type', key : 'activity_type'},
        { title : 'Trip Sequence', key : 'trip_sequence'},
        { title : 'Activity Location', key : 'activity_location'},
        { title : 'City', key : 'city'},
        { title : 'State', key : 'state'},
        { title : 'Pincode', key : 'pincode'},
        { title : 'Distance(Km)', key : 'distance'},
        { title : 'Logistics Cost(₹)', key : 'logistic_cost'},
        { title : 'Activity Date & Time', key : 'activity_date_time'},
        { title : 'Status', key : 'status'},
        { title : 'Remarks', key : 'remarks'},
      ],
      table_data: [],
      search_tag: '',
      selected:[],
      requestImages: [],
      addImagesPopup: false,
      imagePopup: false,
      selectedImage: '',
      requestImagesFileFormat: [],
      requestImageNames: [],
      fileErrorMessage:'',
      fileError: false,
      approveDialog: false,
      file: '',
      inventoryId:'',
      track_id_request:'',
      attachImagePopup: false,
      attach_images:[],
      currentImageIndex: 0,
      configurations: [],
    }
    },
    mounted() {
      this.calculateTableHeight();
      window.addEventListener('resize', this.calculateTableHeight);
    },
    computed: {
      formattedRequestCreationDate() {
        if (!this.result.request_creation_date) return "-";
        const date = new Date(this.result.request_creation_date);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      },
      isRejectDisabled() {
        return this.selected.length != 1 || 
               this.selected.every(item => item.status?.toLowerCase() === 'pending approval' && (item.activity_type === 'Return Drop' || item.activity_type === 'Drop')) ||
               !this.selected.every(item => item.status?.toLowerCase() === 'pending approval');
    },
    selectableItemIds() {
          return this.result?.activities
            ? this.result.activities
                .filter(item => !item.is_sync_to_control_tower)
                .map(item => item.id)
            : [];
          },
          isAllSelectableSelected() {
            const selected_ids = this.selected.map((item) => item.id);
            return (
              this.selectableItemIds.length > 0 &&
              this.selectableItemIds.every((id) => selected_ids.includes(id))
            )
          },
          isIndeterminate() {
            return (
              this.selected.length > 0 && !this.isAllSelectableSelected
            )
          },
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.calculateTableHeight);
    },
    created(){
      this.headerText = this.$store.state.headerTextName
      this.action = this.$store.state.action
      this.configurations = this.$store.state.configurations
      if(this.$store.state.username === 'eurekaforbes'){
          this.configurations = this.configurations.map(config =>{
            if(config.constant === 'CALL_CONTROL_TOWER'){
              config.is_enabled = false
            }
            return config
          })
        }
      this.inventoryId = this.$store.state.inventoryId
      this.track_id_request = this.$store.state.track_id
      this.getShowItem();
    },
    watch:{
    'selected': {
        handler(newVal,oldVal) {
          if(newVal.length > oldVal.length){
            console.log('newVal')
            console.log(newVal)
            const newlySlected = newVal.filter(item => !oldVal.some(oldItem => oldItem.id == item.id));
            console.log('newly selected')
            console.log(newlySlected)
            newlySlected.forEach(item => {
              this.crm_ticket_dupl_details[item.aggregation_id].forEach(data => {
                if(!newVal.some(newItem => newItem.id == data.id)){
                  newVal.push(data)
                }
              });
            })
          } else {
            const newlyUnSlected = oldVal.filter(item => !newVal.some(newItem => newItem.id == item.id));
            newlyUnSlected.forEach(item => {
              this.crm_ticket_dupl_details[item.aggregation_id].forEach(data => {
                const index = newVal.findIndex(newItem => newItem.id === data.id);
                if(index > -1){
                  newVal.splice(index, 1)
                }
              });
            })
          }
        },
        deep: true 
      }
},


    methods: {
      toggleSelectableItems() {
          if (this.isAllSelectableSelected) {
            this.selected = []
          } else {
            this.selected = this.result.activities.filter(
              (item) => this.selectableItemIds.includes(item.id)
            )
          }
        },
      isDuplicate(item) {
        return !item.is_crm_duplicate && this.crm_ticket_dupl_details[item.aggregation_id] && this.crm_ticket_dupl_details[item.aggregation_id].length;
      },
      toggleExpand(data) {
        const index = this.result.activities.findIndex(item => item.aggregation_id === data.aggregation_id);
        if (index > -1) {
          data.is_expanded = !data.is_expanded;
          if (data.is_expanded) {
            this.result.activities.splice(index + 1, 0, ...this.crm_ticket_dupl_details[data.aggregation_id]);
          } else {
            this.result.activities.splice(index + 1, this.crm_ticket_dupl_details[data.aggregation_id].length);
          }
        }
      },
      calculateTableHeight() {
        const viewportHeight = window.innerHeight;
        this.minTableHeight = (viewportHeight - 130) + 'px'
      },
      getRouterLink(){
        return { name: "ftaReverseLogistics" };
      },
      getRouterLinkText(){
      return this.action;
     },
     componentsName(){
      return this.action == 'Logistics Requests' ? this.$store.state.lotIds.return_sub_request_id : this.action == 'Track Trips' ? 
      this.$store.state.lotIds.trip_tag_id : this.$store.state.lotIds.logistic_request_id
     },
     getShowItem(){
      const params = {}
      if(this.search_tag){
        params[this.select_field] = this.search_tag
      }
      const api = this.action == 'Logistics Requests' && !(this.inventoryId == 'Failed Status' || this.track_id_request === 'lr_trip_id') ? `/api/v1/warehouse/return_initiation/logistic_request/show_item?id=${this.$store.state.lotIds.id}` : 
                  this.action == 'Track Trips' ? `/api/v1/warehouse/return_initiation/logistic_request_trips/show_item?id=${this.$store.state.lotIds.id}` : 
                  this.track_id_request == 'lr_trip_id' ? `/api/v1/warehouse/return_initiation/logistic_request_trips/show_item?id=${this.$store.state.lotIds.id}&is_return_item=true&trip_id=${this.$store.state.lotIds.trip_id}` :
                  this.action == 'Logistics Requests' && this.inventoryId == 'Failed Status' ? `/api/v1/warehouse/return_initiation/logistic_request/get_logistic_request_activities?id=${this.$store.state.lotIds.id}`:
                  `/api/v1/warehouse/return_initiation/logistic_request_activities/show_item?id=${this.$store.state.lotIds.id}`
      this.$httpSecured
      .get(api,{ params })
      .then(response => {
        this.result = this.action == 'Logistics Requests' && this.inventoryId != 'Failed Status' && this.track_id_request != 'lr_trip_id'? response.data.return_items[0] : 
                      (this.action == 'Track Trips' || this.track_id_request === 'lr_trip_id') || (this.action == 'Logistics Requests' && this.inventoryId == 'Failed Status') ? response.data : 
                      response.data.logistic_request_activity
        if((this.action == 'Track Trips' || this.track_id_request === 'lr_trip_id') || (this.action == 'Logistics Requests' && this.inventoryId == 'Failed Status')){
          const activities = this.result.activities;
          this.result.activities = [];
          activities.forEach((item, index) => {
            if(!item.id){
              item.id = index+1
            }
            if(item.aggregation_id === null){
              this.result.activities.push(item);
            }else{
              if (index == 0 || item.aggregation_id != activities[index - 1].aggregation_id) {
              item.is_expanded = false;
              this.result.activities.push(item);
              this.crm_ticket_dupl_details[item.aggregation_id] = [];
            } else {
              item.is_crm_duplicate = true;
              this.crm_ticket_dupl_details[item.aggregation_id].push(item);
            }
            }
           
          });
        }
      })
      .catch(error => {
        this.$toast.error(error.response.data.message)
      });
    },
    fetchLogisticDetail(item){
      this.itemInformation = item
      // item.activity_id = 1
      const api = `/api/v1/warehouse/return_initiation/logistic_request_activities/show_item?id=${item.activity_id}`
      this.$httpSecured
        .get(api)
        .then(response => {
          if (response.data) {
            this.referenceDocData = response.data.logistic_request_activity
            this.itemsTableData = [response.data.logistic_request_activity]
            this.referenceDocPopup = true;
          }
        })
        .catch(error => {
          this.$toast.error(error.response.data.message)
          this.loading = false;
        });

      },
    triggerFileInput() {
      // this.$refs.fileInput.click();
      this.addImagesPopup = true; 
    },
    closeImageDialog() {        
      const newImagesCount = this.requestImages.length;
      if (newImagesCount > 0) {
        this.requestImages.splice(this.initialrequestImagesLength, newImagesCount);
        this.requestImageNames.splice(this.initialrequestImagesLength, newImagesCount);
        this.requestImagesFileFormat.splice(this.initialrequestImagesLength, newImagesCount);
      }
      this.addImagesPopup = false;
    },
  
    openImagePopupSingle(image) {
      this.selectedImage = image;
      this.imagePopup = true;
    },
    handleImageUpload(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        this.requestImageNames.push(file.name);
        this.requestImagesFileFormat.push(file);
        const reader = new FileReader();
        reader.onload = (e) => {
            this.requestImages.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },

    handleFileChange() {
      this.loading = true;
      if (this.requestImagesFileFormat.length) {
        const formData = new FormData();
        formData.append("id", this.selected.map(item => item.activity_id).join(','));
        for (let i = 0; i < this.requestImagesFileFormat.length; i++) {
          formData.append('image_fille[]', this.requestImagesFileFormat[i]);
        }
        this.$httpSecured
        .post("/api/v1/warehouse/return_initiation/logistic_request_activities/upload_activities_images", formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(response => {
          this.loading = false;
          this.addImagesPopup = false; 
          this.selected = [];
          this.$toast.success(response.data.message);
        })
        .catch(error => {
          this.loading = false;
          this.$toast.error(error.response.data.message);
        });
      }
    },
    removeImage(index){
      this.requestImages.splice(index, 1);
      this.requestImageNames.splice(index, 1);
      this.requestImagesFileFormat.splice(index,1);
    },
    rejectTrip(){
      const requestData = {
        id: this.selected.map(item => item.activity_id).join(',')
      }
      this.$httpSecured
      .post("/api/v1/warehouse/return_initiation/logistic_request_activities/reject_activity", requestData)
      .then(response => {
        this.loading = false;
        this.selected = [];
        this.$toast.success(response.data.message);
        this.getShowItem();
      })
      .catch(error => {
        this.loading = false;
        if(error.response.data.message)
        this.$toast.error(error.response.data.message);
        else if(error.response.data.error)
        this.$toast.error(error.response.data.error);
      });
    },
    approveTrip(){
      this.approveDialog = true;
      this.file = null;
    },
    changeFile() {
      if (this.file) {
        const fileType = this.file.type;
        if (fileType !== 'application/pdf' && fileType !== 'image/png') {
          this.fileError = true;
          this.fileErrorMessage = 'Only PDF and PNG files are allowed.';
        } else {
          this.fileError = false;
          this.fileErrorMessage = '';
        }

      }
    },
    submitDocument(){
      const formData = new FormData();
      formData.append("id", this.selected.map(item => item.activity_id).join(','));
      const files = Array.isArray(this.file) ? this.file : [this.file];
      for (let i = 0; i < files.length; i++) {
          formData.append('file[]', files[i]);
      }
      this.$httpSecured
      .post("/api/v1/warehouse/return_initiation/logistic_request_activities/approve_activity", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(response => {
        this.loading = false;
        this.approveDialog = false;
        this.selected = [];
        this.$toast.success(response.data.message);
        this.getShowItem();
      })
      .catch(error => {
        this.loading = false;
        this.$toast.error(error.response.data.message);
      });
    },
    updateTripDistance(item){
      this.$set(item, 'isLoading', true);
      this.$httpSecured
      .post("/api/v1/warehouse/return_initiation/logistic_request_trips/update_trip_distance_and_cost",
        {
          "id":item.activity_id,
          "trip_distance":item.trip_distance,
          "logistic_cost":item.logistic_cost
        }
        )
      .then(response => {
          this.snackbar = true;
              this.email_id='';
            this.snackbar = {
                  color: "success",
                  icon: "mdi-check-circle",
                  mode: "multi-line",
                  position: "bottom",
                  timeout: 3000,
                  title: 'Success',
                  text: response.data.message,
                  visible: true
                };
            this.$set(item, 'isLoading', false);     
          this.loadData(this.active_tab)
        }
      )
      .catch(error => {
        this.$set(item, 'isLoading', false);
        this.$toast.error(error.response.data.error)
      });
    },
    handlePageChange(value) {
      this.page = value;
      const params = {
        page: this.page,
        per_page: this.pageSize,
      }
      const api = this.action == 'Track Trips' ? `/api/v1/warehouse/return_initiation/logistic_request_trips/show_item?id=${this.$store.state.lotIds.id}` : 
                                                  `/api/v1/warehouse/return_initiation/logistic_request/get_logistic_request_activities?id=${this.$store.state.lotIds.id}` 
      this.$httpSecured
      .get(api, { params })
      .then(response => {
        this.crm_ticket_dupl_details = {};
        this.result = response.data;
        if (this.action == 'Track Trips' || (this.action == 'Logistics Requests' && this.inventoryId == 'Failed Status')) {
          const activities = this.result.activities;
          this.result.activities = [];
          activities.forEach((item, index) => {
            if (index == 0 || item.aggregation_id != activities[index - 1].aggregation_id) {
              item.is_expanded = false;
              this.result.activities.push(item);
              this.crm_ticket_dupl_details[item.aggregation_id] = [];
            } else {
              item.is_crm_duplicate = true;
              this.crm_ticket_dupl_details[item.aggregation_id].push(item);
            }
          });
        }
      })
      .catch(error => {
        this.$toast.error(error.response.data.message)
      });
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      const params = {
        page: this.page,
        per_page: this.pageSize,
      }
      const api = this.action == 'Track Trips' ? `/api/v1/warehouse/return_initiation/logistic_request_trips/show_item?id=${this.$store.state.lotIds.id}` : 
                                                  `/api/v1/warehouse/return_initiation/logistic_request/get_logistic_request_activities?id=${this.$store.state.lotIds.id}` 
      this.$httpSecured
      .get(api, { params })
      .then(response => {
        this.crm_ticket_dupl_details = {};
        this.result = response.data;
        if (this.action == 'Track Trips' || (this.action == 'Logistics Requests' && this.inventoryId == 'Failed Status')) {
          const activities = this.result.activities;
          this.result.activities = [];
          activities.forEach((item, index) => {
            if (index == 0 || item.aggregation_id != activities[index - 1].aggregation_id) {
              item.is_expanded = false;
              this.result.activities.push(item);
              this.crm_ticket_dupl_details[item.aggregation_id] = [];
            } else {
              item.is_crm_duplicate = true;
              this.crm_ticket_dupl_details[item.aggregation_id].push(item);
            }
          });
        }
      })
      .catch(error => {
        this.$toast.error(error.response.data.message)
      });
    },
    correctDateFormat(data){
      const date = new Date(data);
      const options = { timeZone: "Asia/Kolkata" };
      const istDate = new Date(date.toLocaleString("en-US", options));
      const day = String(istDate.getDate()).padStart(2, '0');
      const month = String(istDate.getMonth() + 1).padStart(2, '0');
      const year = istDate.getFullYear();
      let hours = istDate.getHours();
      const minutes = String(istDate.getMinutes()).padStart(2, '0');
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      hours = String(hours).padStart(2, '0')
      return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
    },
    returnRequestDetailPopup(item,action){
            const modifiedItem = {
              ...item,
              id: item.return_item_id, 
              return_sub_request_id: item.sub_request_id
          };

          this.$store.commit("setRequestDetails",{
            actionRequest : this.headerText,
            items : JSON.stringify(modifiedItem),
          });
            this.$router.push({ name: 'ReturnRequestIdDetailsRia' });
      },
      openAttachDoc(item) {
       this.attachImagePopup = true;
       this.currentImageIndex = 0;
       this.attach_images = item.attached_urls;
       },
       prevImage() {
         if (this.currentImageIndex > 0) {
           this.currentImageIndex--;
         }
       },
       nextImage() {
         if (this.currentImageIndex < this.attach_images.length - 1) {
           this.currentImageIndex++;
         }
       },
      actionEnaledBasedOnControlTower(){
      if(this.configurations.some(item => item.constant === "CALL_CONTROL_TOWER" && item.is_enabled === true)){
          return true
      }
    },
    isRowDisabled(item) {
        return item.is_sync_to_control_tower;
      },
      toggleSelect(item, shouldSelect) {
        const index = this.selected.findIndex(i => i.id === item.id)
        if (shouldSelect && index === -1) {
          this.selected.push(item)
        } else if (!shouldSelect && index !== -1) {
          this.selected.splice(index, 1)
        }
      },
  }
}
  </script>
  <style scoped>
  .value_css{
    font-weight: 600;
    font-size: 14px;
    line-height: 16.94px;
  }
  .image-container {
  position: relative;
  display: inline-block;
  }
  .lot-image {
    width: 186px;
    height: 184px;
    cursor: pointer;
  }
  .cancel-icon {
    position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;
    background-color: #ffff;
  }
  .image-rad-size{
    width: 186px;
    height: 184px;
    border-radius: 8px;
  }
  .track-trips-table {
    height: calc(var(--vh, 1vh) * 100 - 383px) !important;
  }
  .logistics-requests-failed-table {
    height: calc(var(--vh, 1vh) * 100 - 195px) !important;
  }

  :deep(.track_id_table .v-data-table) {
    height: calc(var(--vh, 1vh) * 100 - 375px) !important;
  }
  </style>